import React from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Button, useTheme } from '@mui/material';
import SvgIcon from '../../../Helpers/Svg/SvgIcon';
import "./ServiceValue.scss";

export default function ServiceValue({ data, customData, scrollToElement }) {
  const currentData = !customData ? data : customData;

  return (
    <div className="service-value-wrapper">
      <Container>
        <div className="service-value-container">
          <h2>Peace of mind in a few steps</h2>
          <div className="service-value-card-container">
            <ul>
              {currentData.map((item, index) => {
                return <ServiceValueItem key={(`serviceValue${index}`)} title={item.title} description={item.description} iconName={item.iconName}/>
              })}
            </ul>
          </div>
          <Button onClick={() => scrollToElement("service-value")} className="buttonStyles" variant="contained">
              Learn More
            </Button>
        </div>
      </Container>
    </div>
  );
}

export function ServiceValueItem({ iconName, title, description }) {
 
const theme = useTheme();
 
  return (
    <li className={"service-value-card"}>
      <h3><SvgIcon viewBox={"0 0 40 40"} iconName={iconName} color={theme.palette.primary.main} /><span>{title}</span></h3>
      <p>{description}</p>
    </li>
  )
}

ServiceValue.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })),
  customData:  PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })),
};

ServiceValueItem.propTypes = {
  iconName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
